import React from 'react';
import { useState, useEffect, useRef } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';

const Bankaccountdetails = () => {

  const [Bankaccount, setBankaccount] = useState([]);

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const getBankaccount = async () => {
    try {
      const response = await axios.get("https://apimlm.bloomitsolutions.in/userroutes/getAllUserBankDetails");
      const empData = response.data;
      setBankaccount(empData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getBankaccount();
  }, []);


  return (
    <div>
      <Container>

        <div className='container'>
          <div className='row '>
            <div className='col-lg-12 '>
              <div className='row ' style={{ display: "flex" }} >
              </div>
              <div className="row ">
                <div className="col-lg-6 mt-4  ">

                </div>
              </div>

              <div className="row mt-4">
                <div className="col-lg-12">


                  <div className="card" ref={componentRef}>
                    <div className="card-header" style={{ backgroundColor: "rgb(0,156,216)", color: 'white' }}>
                      <h4> Update Bank details</h4>
                    </div>

                    <div className="card-body">

                      <form>
                        <div className="card-body">
                          <div className='table-responsive'>
                            <table className="table table-bordered">

                              <thead>
                                <tr>
                                  <th scope="col">Sl No</th>
                                  <th scope="col">User Id</th>
                                  <th scope="col">Account Holder Name</th>
                                  <th scope="col">Account Number</th>
                                  <th scope="col">Account Type</th>
                                  <th scope="col">IFSC</th>
                                  <th scope="col">Bank Name</th>
                                  <th scope="col">Bank Branch</th>

                                </tr>
                              </thead>

                              <tbody>
                                {
                                  Bankaccount.map((product, index) => (
                                    <tr key={index}>
                                      <td>{product.id}</td>
                                      <td>{product.userId}</td>
                                      <td>{product.accountHolderName}</td>
                                      <td>{product.accNo}</td>
                                      <td>{product.accType}</td>
                                      <td>{product.ifsc}</td>
                                      <td>{product.bankName}</td>
                                      <td>{product.bankBranch}</td>

                                      {/* <td>
                                    <button className='btn btn-primary'>Edit</button>
                                    <button className='btn btn-danger'>Delete</button>
                                    </td> */}
                                    </tr>
                                  ))
                                }
                              </tbody>

                            </table>
                            <nav aria-label="...">
                              <ul class="pagination">
                                <li class="page-item disabled">
                                  <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
                                </li>
                                <li class="page-item active"><a class="page-link" href="#">1</a></li>
                                <li class="page-item" aria-current="page">
                                  <a class="page-link" href="#">2</a>
                                </li>
                                <li class="page-item"><a class="page-link" href="#">3</a></li>
                                <li class="page-item">
                                  <a class="page-link" href="#">Next</a>
                                </li>
                              </ul>
                            </nav>
                          </div>

                        </div>
                        {/* /.card-body */}
                      </form>
                      <Link to="/BankDetails">
                        <button className='btn btn-info mx-2 mt-1'>Back</button></Link>
                      <Button className='rounded-1 mx-2 mt-1' onClick={handlePrint} >Download PDF</Button>                        </div>
                    </div>
                   
                 
                </div>
              </div>










            </div>

          </div>


        </div>



      </Container>


    </div>
  )
}

export default Bankaccountdetails;